<div class="modal-header">
  <h4 class="modal-title">Confirm Delete</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>
<div class="modal-body">
  <p>Are you sure you want to delete this MSISDN range?</p>
  <div class="alert alert-warning">
    <strong>Range Name:</strong> {{ rangeName }}<br>
    <strong>Start Number:</strong> {{ startNumber }}<br>
    <strong>End Number:</strong> {{ endNumber }}<br>
    <strong>Service Provider:</strong> {{ serviceProvider }}
  </div>
  <p class="text-danger"><small>This action cannot be undone.</small></p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()">No</button>
  <button type="button" class="btn btn-danger" (click)="confirmDelete()">Yes, Delete</button>
</div> 